import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { API_BASE_URL } from '../../_shared';

const axiosClient = axios.create({
	baseURL: API_BASE_URL.FORMS,
	withCredentials: true,
});

/**
 * React hook that manages state for a list of forms.
 *
 * @param {Object} options               The hook options.
 * @param {String} options.scope         The scope.
 * @param {String} options.scope_id      The scope ID.
 * @param {String} [options.language]    The preferred language of the current user.
 * @param {String|Array} [options.type]  The form type(s) to filter by.
 *
 * @returns {Object}   -
 * @returns {Array}    -.forms     The list of forms.
 * @returns {Function} -.setForms  Callback function to change the forms state.
 * @returns {Object}   -.error     The error, if encountered.
 * @returns {Function} -.setError  Callback function to change the error state.
 */
const useForms = (options = {}) => {

	const [forms, setForms] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {

		axiosClient.get('/', {
			params: {
				language: options.language,
				type: options.type,
				scope: options.scope,
				scope_id: options.scope_id,
			}
		}).then((response) => {

			if (response?.data) {
				setForms(response.data);
			}

		}).catch((err) => {

			console.error(err);
			setError(err);

		});

	}, [
		options.language,
		options.type,
		options.scope,
		options.scope_id,
	]);

	return {
		forms,
		setForms,
		error,
		setError,
	};

};

export default useForms;
